<template>
  <div>
    <a-card :bordered="false" title="试算平衡表">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="8" :sm="24"><a-form-item label="截止月份" :labelCol="labelCol" :wrapperCol="wrapperCol"><a-month-picker v-model="endMoment" format="YYYY-MM" style="width:100%" /></a-form-item></a-col>
            <a-col :md="8" :sm="24"><a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol"><store-tenant-select domain="finance" @change="handleStoreTenantChange"></store-tenant-select></a-form-item></a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table bordered size="middle" rowKey="key" :columns="columns" :dataSource="tableData" :pagination="false" :loading="loading" :rowClassName="rowClassName" :scroll="tableScroll" />
      <div v-if="hasData" style="margin-top: 8px;">
        试算平衡：
        <span v-for="item in balanceItems" :key="item.label" :style="{ color: item.ok ? '#52c41a' : '#f5222d' }" style="margin-right: 12px;">{{ item.label }}借{{ item.ok ? '=' : '≠' }}贷</span>
        <a-alert v-if="!balanced" style="margin-top: 8px;" type="error" show-icon :message="message || '试算不平衡'" />
      </div>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { trialBalance, accountSetCurrent } from './api'
import StoreTenantSelect from '@/components/StoreTenantSelect'

const fmt2 = v => (v === null || v === undefined || v === '' || isNaN(Number(v))) ? '' : Number(v).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const AMOUNT_FIELDS = ['openingDebit', 'openingCredit', 'debitAmount', 'creditAmount', 'endingDebit', 'endingCredit']

export default {
  name: 'TrialBalanceList',
  components: { StoreTenantSelect },
  data() {
    return {
      labelCol: { span: 8 }, wrapperCol: { span: 15, offset: 1 },
      accountSetId: null, endMoment: null, loading: false,
      rows: [], totals: null, balanced: true, message: '',
      tableScroll: { x: 'max-content', y: 400 }
    }
  },
  computed: {
    columns() {
      return [
        { title: '科目编码', dataIndex: 'subject_code', width: 120 },
        { title: '科目名称', dataIndex: 'subject_name' },
        { title: '期初余额', children: [
          { title: '借方', dataIndex: 'openingDebit', align: 'right', width: 120 },
          { title: '贷方', dataIndex: 'openingCredit', align: 'right', width: 120 }
        ] },
        { title: '本期发生额', children: [
          { title: '借方', dataIndex: 'debitAmount', align: 'right', width: 120 },
          { title: '贷方', dataIndex: 'creditAmount', align: 'right', width: 120 }
        ] },
        { title: '期末余额', children: [
          { title: '借方', dataIndex: 'endingDebit', align: 'right', width: 120 },
          { title: '贷方', dataIndex: 'endingCredit', align: 'right', width: 120 }
        ] }
      ]
    },
    hasData() { return this.rows.length > 0 },
    tableData() {
      const rows = this.rows.map((r, i) => {
        const row = { key: r.id || ('r' + i), subject_code: r.subject_code, subject_name: r.subject_name }
        AMOUNT_FIELDS.forEach((f) => { row[f] = fmt2(r[f]) })
        return row
      })
      if (rows.length && this.totals) {
        const t = { key: '__total__', subject_code: '', subject_name: '合计', isTotal: true }
        AMOUNT_FIELDS.forEach((f) => { t[f] = fmt2(this.totals[f]) })
        rows.push(t)
      }
      return rows
    },
    balanceItems() {
      const t = this.totals || {}
      return [
        { label: '期初', ok: this.eq(t.openingDebit, t.openingCredit) },
        { label: '本期', ok: this.eq(t.debitAmount, t.creditAmount) },
        { label: '期末', ok: this.eq(t.endingDebit, t.endingCredit) }
      ]
    }
  },
  created() {
    this.endMoment = moment()
    this.loadCurrent()
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.ant-table')
      if (el) {
        const top = el.getBoundingClientRect().top
        this.tableScroll.y = Math.max(300, window.innerHeight - top - 24)
      }
    })
  },
  methods: {
    eq(a, b) { return Math.abs((Number(a) || 0) - (Number(b) || 0)) < 0.005 },
    loadCurrent() {
      accountSetCurrent({}).then((res) => {
        if (res && res.success && res.data && res.data.id) { this.accountSetId = res.data.id; this.searchQuery() } else { this.$message.warning('尚未建账') }
      })
    },
    searchQuery() {
      if (!this.accountSetId) return
      if (!this.endMoment) { this.$message.warning('请选择截止月份'); return }
      this.loading = true
      trialBalance({ accountSetId: this.accountSetId, endMonth: this.endMoment.format('YYYY-MM') }).then((res) => {
        if (res && res.success && res.data) {
          this.rows = res.data.rows || []
          this.totals = res.data.totals || null
          this.balanced = !!res.data.balanced
          this.message = res.data.message || ''
        } else {
          this.$message.warning((res && res.message) || '查询失败')
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    searchReset() { this.endMoment = moment(); this.searchQuery() },
    handleStoreTenantChange() { this.searchQuery() },
    rowClassName(record) { return record.isTotal ? 'gl-balance-total-row' : '' }
  }
}
</script>

<style scoped>
/deep/ .gl-balance-total-row td { background: #fafafa !important; font-weight: 600; }
</style>
